import React from 'react'
import styles from './FAQMostAsked.module.css'

function FAQMostAsked({question,answer}) {
  return (
    <div className={styles.FAQMostAsked}>
      <b>{question}</b>
      <div className={styles.answer}>{answer}</div>
    </div>
  )
}

export default FAQMostAsked